const state = {
  id: {
    field: {
      empty: 'Field ini harus diisi',
      textOnly: 'Field ini tidak boleh berisi angka',
      emailInput: 'Field harus sesuai format email',
      partiallyEmpty: 'Beberapa field harus dilengkapi',
      nikValidation: 'Field ini harus berisi minimal 15 angka dan maksimal 16 angka'
    },
    dataNotFound: 'Data tidak ditemukan',
    fileNotFound: 'Berkas tidak ditemukan',
    confirm: {
      title: 'Konfirmasi',
      logout: 'Apakah Anda yakin ingin keluar?',
      delete: 'Apakah Anda yakin untuk menghapus?',
      deleteUser: 'Serius Mau Delete Gan?',
      deleteAll: 'Apakah Anda yakin untuk menghapus semua?',
      deleteRow: 'Apakah Anda yakin untuk menghapus baris?',
      leaveDirtyForm: 'Perubahan yang Anda buat tidak akan disimpan',
      editForm: 'Apakah Anda yakin untuk menyimpan perubahan?',
      restoreUser: 'Apakah Anda yakin untuk mengembalikan akun ini?'
    },

    soStatus: {
      UNPAID: 'Belum Dibayar',
      PAID: 'Sudah Dibayar',
      PROCESSED: 'Pesanan Diproses',
      SENT: 'Pesanan Terkirim',
      FINISHED: 'Pesanan Selesai',
      CANCELED: 'Pesanan Dibatalkan'
    },
    poStatus: {
      UNAPPROVED: 'Menunggu Konfirmasi',
      PAID: 'Pembayaran',
      PROCESSED: 'Pesanan Diproses',
      PARTIALLY_DELIVERED: 'Dikirim Sebagian',
      DELIVERED: 'Terkirim Semua',
      CANCELED: 'Pesanan Dibatalkan',
      REJECTED: 'Pesanan Ditolak'
    },
    doStatus: {
      PROCESSED: 'Belum Dijadwalkan',
      SCHEDULED: 'Terjadwal',
      DRIVER_ASSIGNED: 'Sopir Ditugaskan',
      ON_DELIVERY: 'Sedang Dikirim',
      SENT: 'Terkirim',
      RETURN_LETTER: 'SJ Balik',
      FINISHED: 'Selesai',
      CANCELED: 'Dibatalkan'
    },
    invoiceStatusTab: {
      NOT_CREATED: 'Belum Dibuat',
      NOT_PAID: 'Belum Dibayar',
      CREATED: 'Dibuat',
      FP_PROCESSED: 'Proses FP',
      FP_FINISHED: 'Selesai FP',
      FP_REVIEWED: 'Direview',
      TTF_PROCESSED: 'Proses TTF',
      READY_TO_SEND: 'Siap Kirim',
      SENT: 'Terkirim',
      FINISHED_TF: 'Sudah TF',
      PARTIALLY_PAID: 'Dibayar Sebagian',
      PAID: 'Lunas',
      FINISHED: 'Selesai'
    },
    invoiceStatus: {
      NON_CONFIRMED: 'Belum Dikonfirmasi',
      CONFIRMED: 'Sudah Dikonfirmasi',
      PAYMENT: 'Pembayaran',
      REJECTED: 'Ditolak'
    },

    uploadStatus: {
      NOT_UPLOADED: {
        label: 'Belum Diunggah',
        badgeClass: 'custom-badge-red'
      },
      PARTIALLY_UPLOADED: {
        label: 'Diunggah Sebagian',
        badgeClass: 'custom-badge-green'
      },
      UPLOADED: {
        label: 'Sudah Diunggah',
        badgeClass: 'custom-badge-green'
      }
    },
    vendorPaymentStatus: {
      UNPAID: {
        label: 'Belum Dibayar',
        badgeClass: 'custom-badge-red'
      },
      PARTIALLY_PAID: {
        label: 'Dibayar Sebagian',
        badgeClass: 'custom-badge-yellow'
      },
      PAID: {
        label: 'Sudah Dibayar',
        badgeClass: 'custom-badge-green'
      }
    },
    confirmPaymentStatus: {
      UNPAID: {
        label: 'Belum Dibayar',
        badgeClass: 'custom-badge-red'
      },
      UNVERIFIED: {
        label: 'Belum Diverifikasi',
        badgeClass: 'custom-badge-red'
      },
      VERIFIED: {
        label: 'Sudah Diverifikasi',
        badgeClass: 'custom-badge-green'
      }
    },
    tooltip: {
      SKU: {
        InfoProduct: 'Kategori 3, Merek, dan Type Produk agar semakin menarik dan mudah ditemukan oleh pembeli. Tambahkan Variant jika produk memilik pilihan selama berat atau dimensi sama.',
        InfoAlias: 'Tuliskan nama lain dari nama produk yang ditampilkan. contoh: Penyejuk udara, pendingin udara, pengkondisi udara, penyaman udara, erkon, AC',
        InfoSpec: 'Atur jumlah minimal yang harus dibeli untuk produk ini; Jumlah kelipatan yang bisa dibeli; Berat dan Dimensi per satuan minimal pembelian produk setelah dikemas.',
        InfoImage: 'Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300px (Untuk gambar optimal gunakan ukuran minimum 700 x 700 px). Pilih foto produk. Cantumkan min. 3 foto yang menarik agar produk semakin menarik pembeli. Pastikan Photo Produk sudah sesuai untuk Customer Retail dan Bisnis',
        InfoDiscountOngkir: 'Masukan jumlah pembelian untuk mendapatkan Gratis Ongkir; Masukan jumlah barang untuk mendapatkan potongan sesuai diskon tier',
        InfoProductDesc: 'Pastikan deskripsi produk memuat penjelasan detail terkait produkmu agar pembeli mudah mengerti dan menemukan produkmu. Disarankan untuk tidak memasukkan info nomor HP, e-mail supplier produk'
      }
    }
  }
}

export default {
  state
}
